import React from 'react';
import FamilyOverview from './components/FamilyOverview';
import FamilySettings from './components/FamilySettings';
import CreateFamily from './components/CreateFamily';
import AcceptInvite from './components/AcceptInvite';
import FamilyReceipts from './components/FamilyReceipts';
import FamilyCards from './components/FamilyCards';
import FamilyStatements from './components/FamilyStatements';
import FamilyForecast from './reports/FamilyForecast';
import FamilyDashboardWidget from './widgets/FamilyDashboardWidget';

const familyModule = {
  id: 'family',
  displayNameKey: 'module.family',
  icon: 'fa-users',
  order: 30,

  // Sidebar entries intentionally exclude /family/receipts, /family/cards,
  // /family/statements — those duplicated the Receipts/Budget pages. Family
  // scope on those pages is now discovered via the ScopeSwitcher chip on
  // /receipts, /budget/cards, /budget/statements.
  navEntries: [
    { path: '/family',          labelKey: 'family.overview', icon: 'fa-users',      order: 10 },
    { path: '/family/forecast', labelKey: 'family.forecast', icon: 'fa-chart-line', order: 20 },
    { path: '/family/settings', labelKey: 'family.settings', icon: 'fa-cog',        order: 30 },
  ],

  routes: [
    { path: '/family',                 element: <FamilyOverview />,    private: true },
    { path: '/family/receipts',        element: <FamilyReceipts />,    private: true },
    { path: '/family/cards',           element: <FamilyCards />,       private: true },
    { path: '/family/statements',      element: <FamilyStatements />,  private: true },
    { path: '/family/forecast',        element: <FamilyForecast />,    private: true },
    { path: '/family/settings',        element: <FamilySettings />,    private: true },
    { path: '/family/create',          element: <CreateFamily />,      private: true },
    { path: '/family/invite/:token',   element: <AcceptInvite />,      private: true },
  ],

  dashboardWidgets: [
    { key: 'family-overview', component: FamilyDashboardWidget, order: 30 },
  ],

  reportSections: [
    // Family spending is the Family scope of the budget spending reports.
    { key: 'family-debt-forecast', labelKey: 'family.reportDebtForecast', icon: 'fa-chart-line', component: FamilyForecast, order: 200 },
  ],
};

export default familyModule;
